import { Component, effect, Input, SimpleChanges } from '@angular/core';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { SharedService } from 'src/app/common/services/shared.service';
import { UnitTypeEnum } from '../../../models/unit-type-enum';
import { TranslateService } from '@ngx-translate/core';
import { ReportService } from 'src/app/reports/services/report.service';
import { DecimalPipe } from '@angular/common';
import { ReportsChartEnum } from 'src/app/reports/models/enums/reports.enum';

@Component({
  selector: 'app-warehouse-overview-card',
  templateUrl: './warehouse-overview-card.component.html',
  styleUrls: ['./warehouse-overview-card.component.scss']
})
export class WarehouseOverviewCardComponent {
// card Data
  @Input() overviewData: any;
  @Input() uniType:any=null;
  @Input() card_title :string='';
  isShowtransactionDate : boolean = true;

  @Input() box='1';
  lang: string = 'en';
  symble: string = '';

  vacant:number = 0;
  occupied:number = 0;

  constructor(
    private sharedService: SharedService,
    private translate: TranslateService,
    public reportService: ReportService,
    private decimalPipe: DecimalPipe
  ) { 
     effect(() => {
      this.isShowtransactionDate = this.reportService.ttmToggleVariable();
    })

  }

  ngOnInit() {
    this.sharedService.language$.subscribe(lang => {
      this.lang = lang;
      this.symbleType();
    })

  }

  ngOnChanges(changes: SimpleChanges) {
    this.symbleType();
    
      let total = this.overviewData?.occupied_percentage + this.overviewData?.vacant_percentage;
      this.vacant = (this.overviewData?.vacant_percentage * 100) / total;
      this.occupied = (this.overviewData?.occupied_percentage * 100) / total;
   
  } 

  symbleType() {    
    if (this.uniType == UnitTypeEnum.sqm) {
      this.symble = this.translate.instant(GlobalContants.keySymbolContants.squareMeterUnit)
    }
    if (this.uniType == UnitTypeEnum.percentage) {
      this.symble = GlobalContants.keySymbolContants.percentage
    }
    if (this.uniType == UnitTypeEnum.currency) {
      this.symble = this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode));
    }
    if (this.uniType == UnitTypeEnum.currencywithsqm) {
      this.symble = ` ${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))}/${this.translate.instant(GlobalContants.keySymbolContants.squareMeterUnit)}`;
    }
    if (this.uniType == UnitTypeEnum.currencywithsqrt) {
      this.symble = ` ${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))}/${this.translate.instant(GlobalContants.keySymbolContants.squarefeetUnit)}`;
    }
    
  }


  getNumber(nbr: any) {
    return +nbr;
  }

  getFormattedDate(dateString: any) {
    const date = new Date(dateString);
    const day = date.getDate();
    const year = date.getFullYear().toString().slice(-2); // '24'
    const month = date.toLocaleString('default', { month: 'long' }); // 'May'

    // Get ordinal suffix
    const suffix = (n: number) => {
      if (n > 3 && n < 21) return 'th';
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
    return `${day}${suffix(day)} ${month} ${year}'`; // e.g., 15th May 24’
  }

  getOpacityVal(index: number): string {
    // Adjust the factor and starting value as per your requirement
    return (1 - (index * 0.1)).toFixed(2);
  }

  ngOnDestroy() {
  }
}
